import gql from 'graphql-tag'

export const queryContractRetentionList = () => {
	return {
		query: gql`
			{
				contract_retention: conf_contract_retention {
					id
					type
				}
			}
		`,
		update(data) {
			return data.contract_retention.map(item => ({
				id: item.id,
				type: item.type
			}))
		}
	}
}
